import React from 'react';
import styled from 'styled-components';
import { RouteComponentProps } from 'react-router';
import { useQueryParameterDevices } from 'packages/smart-home-support/hooks';
import { getDeviceDisclaimers } from 'packages/smart-home-support/utils';
import CalculatorSelection from './components/CalculatorSelection';
import { CalculatorSelectionTotalLabel, CalculatorSelectionTotalHeadings } from './components/CalculatorSelectionTotal';
import { CalculatorSelectionPageProps } from '../models';
import BREAK_POINTS from '../../../styling/media-queries';
import ContainerColumn from './components/ContainerColumn';

const CalculatorSelectionContainer = styled.div`
  margin-left: 2%;
  margin-right: 2%;
  margin-top: 2%;
  background: #fff;
  padding-top: 45px;
  padding-bottom: 45px;
  @media ${BREAK_POINTS.desktop} {
    display: flex;
    padding-right: 40px;
    justify-content: center;
  }
`;

const InfoColumn = styled(ContainerColumn)`
  flex-shrink: 1;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Headings = styled.div`
  margin: 0 20px;
  @media ${BREAK_POINTS.mobileBig} {
    margin: 0 40px;
  }
  @media ${BREAK_POINTS.desktop} {
    margin-left: 10%;
    margin-right: 0;
  }
`;

const DesktopOnly = styled.div`
  display: none;
  @media ${BREAK_POINTS.desktop} {
    display: inherit;
  }
`;

const MobileOnly = styled.div`
  @media ${BREAK_POINTS.desktop} {
    display: none;
  }
`;

const MobileTotal = styled(MobileOnly)`
  margin: 0 20px;
  @media ${BREAK_POINTS.mobileBig} {
    margin: 0 40px;
  }
`;

const DesktopTotal = styled(DesktopOnly)`
  @media ${BREAK_POINTS.desktop} {
    margin-left: 10%;
  }
`;

const CalculatorSelectionPage: React.FC<CalculatorSelectionPageProps & RouteComponentProps> = ({
  devices,
  location,
  history,
}) => {
  const [queryParameterDevices, setQueryParameterDevices] = useQueryParameterDevices(devices, location, history);

  return (
    <CalculatorSelectionContainer id="val-calc-section">
      <InfoColumn>
        <Headings>
          <CalculatorSelectionTotalHeadings />
        </Headings>
        <DesktopTotal>
          <CalculatorSelectionTotalLabel deviceQuantities={queryParameterDevices} devices={devices} />
        </DesktopTotal>
      </InfoColumn>
      <CalculatorSelection
        devices={devices}
        onChangeDeviceQuantities={setQueryParameterDevices}
        deviceQuantities={queryParameterDevices}
        deviceDisclaimers={getDeviceDisclaimers()}
      />
      <MobileTotal>
        <CalculatorSelectionTotalLabel deviceQuantities={queryParameterDevices} devices={devices} />
      </MobileTotal>
    </CalculatorSelectionContainer>
  );
};
export default CalculatorSelectionPage;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/calculator/selection/index.tsx